package com.sddamico.swigmore.ds.forms

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.PressableStyle
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.SwEffects
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeBody
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Button as DomButton
import org.jetbrains.compose.web.dom.Text

/** [Square]: bordered 30px key (▲ ▼). [Bare]: borderless, dimmed (×). [Round]: circular +/− toggle. [Add]: gold + chip. */
enum class IconButtonVariant { Square, Bare, Round, Add }

/** A glyph-only control. The design uses text glyphs (▲ ▼ × + −) rather than an icon font. */
@Composable
fun IconButton(
  glyph: String,
  label: String,
  modifier: Modifier = Modifier,
  variant: IconButtonVariant = IconButtonVariant.Square,
  onClick: (() -> Unit)? = null,
) {
  val handler = onClick
  val shape = when (variant) {
    IconButtonVariant.Square -> Modifier.typeBody("11px", 600, "1").css(
      "width" to "30px", "height" to "30px", "border-radius" to SwEffects.radiusSm,
      "border" to "1.5px solid rgba(29,77,54,.3)", "background" to "transparent", "color" to SwColor.field700)
    IconButtonVariant.Bare -> Modifier.typeBody("16px", 600, "1").css(
      "width" to "30px", "height" to "30px", "border-radius" to SwEffects.radiusSm,
      "border" to "none", "background" to "transparent", "color" to SwColor.field700, "opacity" to ".6")
    IconButtonVariant.Round -> Modifier.typeBody("15px", 600, "1").css(
      "width" to "26px", "height" to "26px", "border-radius" to "50%",
      "border" to "1.5px solid ${SwColor.borderOnCream}", "background" to "transparent", "color" to SwColor.field700)
    IconButtonVariant.Add -> Modifier.typeBody("14px", 800, "1").css(
      "width" to "24px", "height" to "24px", "border-radius" to "50%",
      "border" to "none", "background" to SwColor.gold, "color" to SwColor.field700)
  }
  DomButton(
    attrs = PressableStyle.toModifier()
      .css("display" to "flex", "align-items" to "center", "justify-content" to "center", "padding" to "0",
        "flex" to "0 0 auto", "cursor" to "pointer")
      .then(shape)
      .then(modifier)
      .toAttrs {
        attr("type", "button")
        attr("aria-label", label)
        if (handler != null) onClick { ev -> ev.stopPropagation(); handler() }
      }
  ) { Text(glyph) }
}
